import {createEvent, createStore, sample} from 'effector';
import {delay} from 'patronum'

export const $notification = createStore({
    severity: null,
    summary: null,
    detail: null
})

export const showErrorEv = createEvent()
export const showSuccessEv = createEvent()
export const showInfoEv = createEvent()
const resetTrigger = createEvent()
const resetNotificationEv = delay(resetTrigger, 5000)

$notification.on(showErrorEv, (state, ev) => ({severity: 'error', summary: ev.summary, detail: ev.detail}))
    .on(showSuccessEv, (state, ev) => ({severity: 'success', summary: ev.summary, detail: ev.detail}))
    .on(showInfoEv, (state, ev) => ({severity: 'info', summary: ev.summary, detail: ev.detail}))
    .reset(resetNotificationEv)

sample({
    clock: [showInfoEv, showSuccessEv, showErrorEv],
    target: resetTrigger
})